<template>
  <div class="gym-exchange-betterwe-token">
    <AppLoading class="loading"></AppLoading>
  </div>
</template>

<script>
import AppLoading from '@/components/app/loading/loading.vue'
export default {
  components: { AppLoading },
  data() {
    return {}
  },
  created() {
    this.getBtwTokenByGymToken()
  },
  methods: {
    async getBtwTokenByGymToken() {
      let jmToken = this.$http._getCookie('jmToken')
      let res = await this.$http
        .get('coach/Survey?a=getBtwToken', { token: jmToken })
        .catch((err) => {
          this.$toast('异常错误')
        })
      if (res) {
        res = res.data
        if (res.code == 200) {
          let token = res.data
          localStorage.setItem('token', token)
          let url = this.$route.query.url
          if (url) {
            this.$router.replace(`/${url}`)
          }
          //let redirectUrl = this.$route.query.redirectUrl
          //location.replace(redirectUrl);
        } else {
          this.$toast(res.msg)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.loading {
  position: fixed;
  left: 50%;
  top: 30%;
  transform: translate(-50%, -50%);
}
</style>
